import script from "./SchedulingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SchedulingPage.vue?vue&type=script&setup=true&lang=ts"

import "./SchedulingPage.vue?vue&type=style&index=0&id=311e6105&lang=css"

const __exports__ = script;

export default __exports__